import React, { useState } from "react";
import {
  Message,
  TextArea,
  InputField,
  AddPageShell,
  AddSection,
} from "../components/Component";
import { codeOk, errorMessage } from "../../lib/index";
import { useLanguageContext } from "../../context/LanguageContext";
import { getOneLanguage } from "../../lib/sysNavigation/SysNavigation";
import { HiOutlineTranslate } from "react-icons/hi";

const Edit = () => {
  const { updateLanguageState, updateLanguage } = useLanguageContext();
  const language = getOneLanguage();

  const [error, setError] = useState(false);
  const [status, setStatus] = useState(0);
  const [message, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const language_id = language.language_id;
  const [name, setName] = useState(language.name);
  const [description, setDescription] = useState(language.description);

  const languageRoutes = "/language";

  const cleanFields = () => {
    setLoading(false);
    setSuccess(true);
  };

  const responses = (isError: any, _status: any, _message: any) => {
    setError(isError);
    setStatus(_status);
    setErrorMessage(_message);
  };

  const updateOneLanguageHandler = async (e: any) => {
    e.preventDefault();
    setLoading(true);
    await sendDBRequest();
  };

  const sendDBRequest = async () => {
    const data = { name, description };
    const response = await updateLanguage(language_id, data);

    if (response) {
      if (response.data.status === codeOk) {
        updateLanguageState({ language_id, ...data });
        cleanFields();
        return responses(true, response.data.status, response.data.message);
      } else {
        setLoading(false);
        return responses(true, response.data.status, response.data.message);
      }
    } else {
      setLoading(false);
      return responses(true, 400, errorMessage);
    }
  };

  return (
    <AddPageShell
      backRoute={languageRoutes}
      eyebrow="Catalog • Languages"
      title="Edit Language"
      subtitle="Updated the name and description of this language."
      icon={<HiOutlineTranslate className="h-5 w-5" />}
      size="md"
      loading={loading}
      submitLabel="Save Changes"
      onSubmit={updateOneLanguageHandler}
      onSubmitClick={() => {
        setError(false);
        setSuccess(false);
        setErrorMessage("");
      }}
      message={
        <Message
          props={{
            error,
            success,
            message,
            loading,
            status,
            onClick: () => {
              setError(false);
              setSuccess(false);
              setErrorMessage("");
            },
          }}
        />
      }
    >
      <AddSection
        title="Language Details"
        hint="Used across the dashboard to label localized content."
      >
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
          <InputField
            props={{
              id: "title",
              title: "Name",
              type: "text",
              required: true,
              value: name ? name : "",
              onChange: (e: any) => {
                setName(e.target.value);
                setError(null);
                setSuccess(null);
              },
            }}
          />
          <div className="md:col-span-2">
            <TextArea
              props={{
                id: "description",
                title: "Description",
                type: "text",
                required: true,
                value: description ? description : "",
                onChange: (e: any) => {
                  setDescription(e.target.value);
                  setError(null);
                  setSuccess(null);
                },
              }}
            />
          </div>
        </div>
      </AddSection>
    </AddPageShell>
  );
};

export default Edit;
